import axios from "axios";
import router from "../../router";

export default {
  namespaced: true,
  state: {
    loggedIn: false,
    idActionsRol: [],
    idGrupos: [],
    modules: [],
    /*deniedCompany: {
      title: "Error!",
      html: "La empresa no tiene permiso a esa sección",
      timer: 15000,
      icon: "error",
      confirmButtonColor: "#d60400",
    },*/
    deniedUser: {
      title: "Error!",
      html: "Usted no tiene permiso a esa sección",
      timer: 15000,
      icon: "error",
      confirmButtonColor: "#d60400",
    },
  },
  mutations: {
    setLogedIn(state, payload) {
      state.loggedIn = payload;
    },

    setActionsRol(state) {
      state.idActionsRol = [];
      if (localStorage.getItem("user") != "") {
        let user = JSON.parse(localStorage.getItem("user"));
        state.idActionsRol.push("HOME");
        for (let permission of user.permission) {
          let action = state.idActionsRol.find((e) => e === permission);
          if (typeof action == "undefined") {
            state.idActionsRol.push(permission);
          }
        }
        state.idGrupos = [];
        for (let grupo of user.grupos) {
          let action = state.idGrupos.find((e) => e === grupo);
          if (typeof action == "undefined") {
            state.idGrupos.push(grupo);
          }
        }
      }
    },

    setAvailableModules(state) {
      if (localStorage.getItem("user") != "") {
        let user = JSON.parse(localStorage.getItem("user"));
        state.modules = user.modules;
      }
    },
  },
  actions: {
    errorRequest({ dispatch, rootState }, payload) {
      //console.log("entró en el errorRequest");

      rootState.master.alertas = "";
      let errorValidacion = false;

      errorValidacion = payload.data.status === 422;

      if (errorValidacion) {
        // ERROR DE VALIDACION DEL REQUEST

        let messages = payload.data.response.data.validation_messages;

        // console.log(messages);
        Object.keys(payload.data.response.data.validation_messages).forEach(
          (item) => {
            let msg = messages[item];
            //console.log(typeof msg);

            if (typeof msg == "object") {
              Object.keys(msg).forEach((item2) => {
                rootState.master.alertas += msg[item2] + "<br />";
              });
            } else {
              for (let i = 0; i < msg.length; i++) {
                rootState.master.alertas += msg[i] + "<br />";
              }
            }
          }
        );
      } else if (payload.data.status === 500) {
        // MAYORMENTE ERROR DE PROGRAMACIÓN
        if (typeof payload.data.datos != "undefined") {
          let i = 1;
          Object.keys(payload.data.datos).forEach((item) => {
            let msg = payload.data.datos[item];
            if (i < 5) rootState.master.alertas += item + " " + msg + "<br />";
            i++;
          });
        } else {
          // console.log(payload.data.response.data);
          rootState.master.alertas += payload.data.response.data.detail;
        }
      } else {
        rootState.master.alertas =
          "Ha ocurrido un error inesperado, intente nuevamente";
      }

      /* if(typeof payload.data.btn == "undefined" && state.loadingBtn)
                commit('master/setLoadingBtn',false, { root: true })
            else if(payload.data.btn===2)
                commit('master/setLoadingBtn2',false, { root: true }) */

      let error500 = !(
        typeof payload.data != "undefined" && payload.data.status === 500
      );
      //error500 = payload.data.response.data.msg;
      let data = {
        param: {
          title: "Error!",
          html: rootState.master.alertas,
          icon: "error",
          toast: error500,
          timer: !error500 ? 25000 : rootState.master.sweetAlert.timer,
          position: rootState.master.sweetAlert.position,
          confirmButtonColor: "#d60400",
        },
      };
      dispatch("master/alertNotification", data, { root: true });
    },

    login({ state, commit, rootState, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        commit("master/setLoadingBtn", true, { root: true });
        commit("master/setUrl", "api/login", { root: true });

        axios
          .post(rootState.master.url, {
            user_name: payload.user,
            user_pass: payload.password,
            grant_type: "client_credentials",
          })
          .then((res) => {
            resolve(res);

            if (
              res.statusText === "OK" &&
              res.status === 200 &&
              res.data.access_token
            ) {
              let token = res.data.access_token;
              localStorage.setItem("token", token);

              commit("master/setUrl", "api/datos-usuario", { root: true });

              axios
                .post(rootState.master.url, {
                  user_name: payload.user,
                  system: "portal_siglobpo",
                  //dataBase: payload.company,
                  comment: "Ha iniciado sesión ",
                })
                .then((res) => {
                  //console.log(res);
                  let userString = JSON.stringify(res.data.user);
                  localStorage.setItem("user", userString);
                  dispatch("checkSessionStatus");
                  commit("master/setMenu");
                  //window.location.replace("/");

                  router.push({ path: "/", reload: false });

                  dispatch(
                    "master/alertNotification",
                    {
                      param: {
                        toast: true,
                        timer: 1000,
                        html: "Bienvenido " + payload.user,
                      },
                    },
                    { root: true }
                  );
                });
            }
          })
          .catch((err) => {
            //reject(err);

            if (!state.loadingBtn)
              commit("master/setLoadingBtn", null, { root: true });

            let response = err.response;

            if (!response.data.login) {
              dispatch(
                "master/alertNotification",
                {
                  param: {
                    title: "Error",
                    icon: "error",
                    html: "El usuario o contraseña son incorrectos",
                    confirmButtonColor: "#d60400",
                  },
                },
                { root: true }
              );
            } else {
              dispatch(
                "errorRequest",
                {
                  data: {
                    datos: response.data.errors,
                    status: response.status,
                  },
                },
                { root: true }
              );
            }
          });
      });
    },

    checkSessionStatus({ commit }) {
      let existToken =
        localStorage.getItem("token") != null &&
        localStorage.getItem("token") !== undefined &&
        typeof localStorage.getItem("token") !== "undefined";

      if (existToken) {
        commit("master/setToken", localStorage.getItem("token"), {
          root: true,
        });

        if (localStorage.getItem("user") != null) {
          commit("master/setUser", JSON.parse(localStorage.getItem("user")), {
            root: true,
          });
          commit("setActionsRol");
          //commit('setAvailableModules')
          commit("setLogedIn", true);
        }
      }
    },

    recuperar({ state, commit, dispatch, rootState }, payload) {
      return new Promise((resolve, reject) => {
        commit("master/setLoadingBtn", true, { root: true });
        commit("master/setUrl", "api/request-password-change", { root: true });
        //localStorage.setItem('tenantId',payload.company)

        axios
          .post(rootState.master.url, {
            userName: payload.userName,
          })
          .then((res) => {
            resolve(res);

            /*if (
              res.statusText === "OK" &&
              res.status === 200 &&
              res.data.access_token
            ) {
            }*/
          })
          .catch((err) => {
            reject(err);

            if (!state.loadingBtn)
              commit("master/setLoadingBtn", null, { root: true });

            let response = err.response;

            if (!response.data.login) {
              dispatch(
                "master/alertNotification",
                {
                  param: {
                    title: "Error",
                    icon: "error",
                    html: "El usuario o contraseña son incorrectos",
                    confirmButtonColor: "#d60400",
                  },
                },
                { root: true }
              );
            } else {
              dispatch(
                "errorRequest",
                {
                  data: {
                    datos: response.data.errors,
                    status: response.status,
                  },
                },
                { root: true }
              );
            }
          });
      });
    },

    cambiarPassword({ state, commit, dispatch, rootState }, payload) {
      return new Promise((resolve, reject) => {
        commit("master/setLoadingBtn", true, { root: true });
        commit("master/setUrl", "api/change-password", { root: true });
        //localStorage.setItem('tenantId',payload.company)

        axios
          .post(rootState.master.url, {
            token: payload.token,
            password: payload.password,
          })
          .then((res) => {
            resolve(res);
            window.location.replace("#/login");
            /*if (
              res.statusText === "OK" &&
              res.status === 200 &&
              res.data.access_token
            ) {
            }*/
          })
          .catch((err) => {
            reject(err);

            if (!state.loadingBtn)
              commit("master/setLoadingBtn", null, { root: true });

            let response = err.response;

            if (!response.data.login) {
              dispatch(
                "master/alertNotification",
                {
                  param: {
                    title: "Error",
                    icon: "error",
                    html: "El usuario o contraseña son incorrectos",
                    confirmButtonColor: "#d60400",
                  },
                },
                { root: true }
              );
            } else {
              dispatch(
                "errorRequest",
                {
                  data: {
                    datos: response.data.errors,
                    status: response.status,
                  },
                },
                { root: true }
              );
            }
          });
      });
    },

    activarCuenta({ state, commit, dispatch, rootState }, payload) {
      return new Promise((resolve, reject) => {
        commit("master/setLoadingBtn", true, { root: true });
        commit("master/setUrl", "api/activar-cuenta", { root: true });
        //localStorage.setItem('tenantId',payload.company)

        axios
          .post(rootState.master.url, {
            token: payload.token,
            password: payload.password,
          })
          .then((res) => {
            resolve(res);
            window.location.replace("#/login");
            /*if (
              res.statusText === "OK" &&
              res.status === 200 &&
              res.data.access_token
            ) {
            }*/
          })
          .catch((err) => {
            reject(err);

            if (!state.loadingBtn)
              commit("master/setLoadingBtn", null, { root: true });

            let response = err.response;

            if (!response.data.login) {
              dispatch(
                "master/alertNotification",
                {
                  param: {
                    title: "Error",
                    icon: "error",
                    html: "El usuario o contraseña son incorrectos",
                    confirmButtonColor: "#d60400",
                  },
                },
                { root: true }
              );
            } else {
              dispatch(
                "errorRequest",
                {
                  data: {
                    datos: response.data.errors,
                    status: response.status,
                  },
                },
                { root: true }
              );
            }
          });
      });
    },

    /**
          getModules({state,commit,dispatch,rootState}){
      
            commit('master/setUrl',`user-laboratorio/${rootState.master.tenantId}`,{ root: true })
            dispatch('master/requestApi',{
                method: 'PUT',
                data:{}
            },{ root: true })
            .then(res=>{
                let user = JSON.parse(localStorage.getItem('user'))
                user.modules = res.data.modules
                user.permission = res.data.permission
                localStorage.setItem('user',JSON.stringify(user))
                commit('setActionsRol')
                commit('setAvailableModules')
            }) 

        } **/
  },
  getters: {    
    // GETTERS ACCESS IS LOGGED IN
    getIsLoggedIn(state) {
      return state.loggedIn;
    },

    // GETTERS ACCESS COMPANY APPLICATION

    inicio(state) {
      return state.idActionsRol.find((e) => e === "HOME");
    },

    // GETTERS ACCESS USER PERMISSIONS

    supervisor(state) {
      return state.idGrupos.find((e) => e === 13);
    },

    adminrh(state) {
      return state.idGrupos.find((e) => e === 9);
    },

    adminportal(state) {
      return state.idGrupos.find((e) => e === 4);
    },

    /** Devuelve la lista de empresas de las que el usuario es adinistrador (grupo 9 RH) **/
    empresasAdminRh(states) {      
      let user = JSON.parse(localStorage.getItem("user"));
      let empresas =  [];
      for (let permiso of user.empresas) {
        if (permiso.group_id === 9) {
          empresas.push({
            empresa_id: permiso.empresa_id,
            empresa_nombre: permiso.empresa_nombre,
          });
        }      
      }
      return empresas;
    },

    /** devuelve la lista de empresas de las que el usuario es supervisor (grupo 13 ) **/
    empresasSupervisor(states) {      
      let user = JSON.parse(localStorage.getItem("user"));
      let empresas =  [];
      for (let permiso of user.empresas) {
        if (permiso.group_id === 13) {
          empresas.push({
            empresa_id: permiso.empresa_id,
            empresa_nombre: permiso.empresa_nombre,
          });
        }      
      }
      return empresas;
    },

    empresasUsuario(states) {      
      let user = JSON.parse(localStorage.getItem("user"));
      return user.empleados;
    },
  },
};
